import { withInstall } from '@xzx-design/utils'
import _Button from './src/button.vue'
import _ButtonGroup from './src/button-group.vue'

export const Button = withInstall(_Button)
export default Button
export const ButtonGroup = withInstall(_ButtonGroup)

export * from './src/button'
export * from './src/types'
